import DirectoryEditor from "./DirectoryEditor";

export default function Designations() {
  return (
    <DirectoryEditor
      resource="designations"
      title="Designations"
      eyebrow="Administration · Directory"
      description="Master list of designations offered to employees. Distinct from Roles — Roles drive permissions, Designations describe the job title on the org chart."
    />
  );
}
